import React from "react";
import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

import { mauritiusText } from "./texts";
import beachImg from "../../../../assests/images/MauritiusBeach.png";
import peopleImg1 from "../../../../assests/images/people1.png";
import peopleImg2 from "../../../../assests/images/people2.png";
import artImg1 from "../../../../assests/images/art1.png";
import artIm2 from "../../../../assests/images/art2.png";
import animalImg1 from "../../../../assests/images/animal1.png";
import animalImg2 from "../../../../assests/images/animal2.png";

import busImg from "../../../../assests/images/busImg.png";
const StyledDialog = styled.div``;

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 35rem;
  margin-top: 3rem;
  box-shadow: 0 2rem 4rem rgba(0, 0, 0, 0.06);
  border: 1px solid #f4f2f2;
  // shadow: 0 2rem 6rem rgba(0,0,0,.3)

  // shadow: 0 2rem 6rem rgba(0,0,0,.3)
`;

const StyledHeader = styled.div`
  text-transform: uppercase;
  font-weight: 400;
  font-size: 18px;
  padding: 2rem;
`;

const StyledText = styled.div`
  position: absolute;
  right: 0;
  bottom: 0px;
  font-size: 16px;
  font-weight: 300;
  left: 4rem;
  z-index: 90;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 1rem;
`;

const ImageContainer = styled.div`
  width: 100%;
  position: relative;
  height: auto;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 24rem;
  object-fit: cover;
`;

const StyledButton = styled(Button)`
  &&& {
    position: relative;
    float: right;
    font-size: 16px;
    color: gray;
    padding-right: 4px;
  }
`;

const StyledTypo = withStyles({
  root: {
    color: "gray",
    fontWeight: 400,
    fontSize: "16px",
    paddingBottom: "1rem",
    textAlign: "justify",
  },
})(Typography);

const BackTitle = styled.h2`
  color: gray;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 20px;
  padding: 2rem;
`;

const WhyContainerNew = styled.div`
  justify-content: center;
  display: grid;
  grid-template-columns: min-content repeat(2, 15rem);
  grid-column-gap: 2rem;
  grid-row-gap: 1.5rem;
  margin-bottom: 2rem;
  margin-top: 3rem;
`;

const Number = styled.div`
  font-size: 6rem;
  font-weight: 600;
`;

const ImageFull = styled.div`
  grid-column: 2 / -1;
`;

const TextNew = styled.div`
  grid-column: 2 / -1;
`;

const ImageVertLeft = styled.div`
  grid-column: 2 / 3;
`;

const ImageVertRight = styled.div`
  grid-column: 3 / -1;
`;

const ImageHoriTop = styled.div`
  grid-column: 2 / -1;
  grid-row: 1 / 2;
`;

const ImageHoriBottom = styled.div`
  grid-column: 2 / -1;
  grid-row: 2 / 3;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

class Why extends React.Component {
  state = {
    open: false,
    scroll: "paper",
  };

  handleClickOpen = (scroll) => () => {
    this.setState({ open: true, scroll });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <StyledDialog>
        <StyledCard>
          <StyledHeader>Why Mauritius</StyledHeader>
          <ImageContainer>
            <StyledImage src={beachImg} alt="Why did we choose Mauritius ?" />
            <StyledText>Why did we choose Mauritius ?</StyledText>
          </ImageContainer>
          <div>
            <StyledButton
              aria-label="More"
              variant="text"
              onClick={this.handleClickOpen("paper")}
            >
              More
              <KeyboardArrowRight />
            </StyledButton>
          </div>
        </StyledCard>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={this.state.scroll}
          aria-labelledby="scroll-dialog-title"
        >
          <BackTitle id="scroll-dialog-title">Why Mauritius</BackTitle>
          <DialogContent>
            <DialogContentText>
              <StyledTypo>{mauritiusText.mainText}</StyledTypo>
              <WhyContainerNew>
                <Number>1</Number>
                <ImageFull>
                  <img src={beachImg} alt="The Paradise" />
                </ImageFull>
                <TextNew>{mauritiusText.firstText}</TextNew>
              </WhyContainerNew>
              <WhyContainerNew>
                <Number>2</Number>
                <ImageVertLeft>
                  <Image src={peopleImg1} alt="People of Mauritius" />
                </ImageVertLeft>
                <ImageVertRight>
                  <Image src={peopleImg2} alt="People of Mauritius" />
                </ImageVertRight>
                <TextNew>{mauritiusText.secondText}</TextNew>
              </WhyContainerNew>
              <WhyContainerNew>
                <Number>3</Number>
                <ImageFull>
                  <img src={busImg} alt="Mauritius Ice Creme Truck" />
                </ImageFull>
                <TextNew>{mauritiusText.thirdText}</TextNew>
              </WhyContainerNew>
              <WhyContainerNew>
                <Number>4</Number>
                <ImageHoriTop>
                  <Image src={artImg1} alt="The Art of Mauritius" />
                </ImageHoriTop>
                <ImageHoriBottom>
                  <Image src={artIm2} alt="The Art of Mauritius" />
                </ImageHoriBottom>
                <TextNew>{mauritiusText.forthText}</TextNew>
              </WhyContainerNew>
              <WhyContainerNew>
                <Number>5</Number>
                <ImageVertLeft>
                  <Image src={animalImg1} alt="Animals of Mauritius" />
                </ImageVertLeft>
                <ImageVertRight>
                  <Image src={animalImg2} alt="Animals of Mauritius" />
                </ImageVertRight>
                <TextNew>{mauritiusText.fifthText}</TextNew>
              </WhyContainerNew>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <IconButton onClick={this.handleClose} color="gray">
              <Close />
            </IconButton>
          </DialogActions>
        </Dialog>
      </StyledDialog>
    );
  }
}

export default Why;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/Why.js